import { useEffect, useState } from 'react';

/**
 * https://usehooks.com/useDebounce/
 * @template Value
 * @param value - a value that may change frequently
 * @param delay - milliseconds to debounce
 * @returns the debounced value
 */
export const useDebounce = <Value>(value: Value, delay: number): Value => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
